import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["key"];
import { useEffect, useState, useCallback } from 'react';
import { useDataPassingContext } from 'automation-ui-formula-editor/data-passing-panel/DataPassingContext';
export let ScrollToItemType;
(function (ScrollToItemType) {
  ScrollToItemType["PROPERTY"] = "PROPERTY";
  ScrollToItemType["DATASOURCE"] = "DATASOURCE";
})(ScrollToItemType || (ScrollToItemType = {}));
function useScrollDataPanelToDataToken() {
  const {
    refScrollDataPanelDataTokenStore
  } = useDataPassingContext();
  const [refStore, setRefStore] = refScrollDataPanelDataTokenStore;
  const [scrollToTokenQueue, setScrollToTokenQueue] = useState();
  const getScrollToRefData = useCallback(key => {
    return refStore[key];
  }, [refStore]);
  useEffect(() => {
    if (!refStore || Object.keys(refStore).length <= 0 || !scrollToTokenQueue || scrollToTokenQueue.length <= 0) {
      return;
    }

    // DEV NOTE: see if we have any of these tokens in our queue
    // we are assuming that one of its parents is registered.
    // when and if we start loading deep nested some of this logic
    // may need to load up data sources and this logic will need to move
    scrollToTokenQueue.some((key, index) => {
      const itemInStore = getScrollToRefData(key);
      if (itemInStore) {
        const {
          ref,
          itemType,
          dataSourceExpanded,
          expandCallback,
          animateCallback
        } = itemInStore;

        // see if it is collapsed and needs to be expanded
        if (itemType === ScrollToItemType.DATASOURCE && !dataSourceExpanded && expandCallback) {
          // open the data source and exit our loop so it has a chance to register
          // its contents
          expandCallback(true);
          setScrollToTokenQueue(scrollToTokenQueue.slice(index + 1, scrollToTokenQueue.length));
          return true;
        }
        if (!ref.current) {
          return false;
        }

        // if this is the last item in line then scroll to it and make it dance
        if (index + 1 === scrollToTokenQueue.length) {
          ref.current.scrollIntoView();
          animateCallback();
          setScrollToTokenQueue([]);
        }
      }
      return false;
    });

    // clear out our queue after a couple of seconds
    setTimeout(() => setScrollToTokenQueue([]), 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollToTokenQueue, refStore]);
  const registerForScrollTo = _ref => {
    let {
        key
      } = _ref,
      args = _objectWithoutPropertiesLoose(_ref, _excluded);
    setRefStore(prevState => Object.assign({}, prevState, {
      [key]: args
    }));
  };
  const queueUpScrollToToken = key => {
    const queue = [];
    const tokenParts = key.split('.');
    let index = 1;
    while (index <= tokenParts.length) {
      queue.push(tokenParts.slice(0, index).join('.'));
      index++;
    }
    setScrollToTokenQueue(queue);
  };
  const executeScrollTo = useCallback(({
    key,
    queueUnfoundTokens = true
  }) => {
    const itemInStore = refStore[key];
    if (itemInStore) {
      const {
        ref,
        animateCallback,
        expandCallback,
        dataSourceExpanded,
        itemType
      } = itemInStore;
      if (ref && ref.current && ref.current.scrollIntoView) {
        ref.current.scrollIntoView();
        animateCallback();
        if (itemType === ScrollToItemType.DATASOURCE && !dataSourceExpanded && expandCallback) {
          expandCallback(true);
        }
        return true;
      }
    }
    if (queueUnfoundTokens) {
      queueUpScrollToToken(key);
    }
    return false;
  }, [refStore]);
  const unregisterForScrollTo = key => {
    setRefStore(prevState => {
      delete prevState[key];
      return prevState;
    });
  };
  return {
    executeScrollTo,
    registerForScrollTo,
    unregisterForScrollTo,
    // getter methods provider for testing hook
    getRefStore: () => refStore,
    getScrollToTokenQueue: () => scrollToTokenQueue
  };
}
export default useScrollDataPanelToDataToken;